import _ 				from "lodash";

import { Service } 		from "./../../Libs/Service";

import { Server } 		from "./Server";
import { Metadata } 	from "./Metadata";
import { Layout } 		from "./Layout";

import { Settings }		from "./Settings";
import SetupSettings from "../settings/settings.json";

let Template = new Service({

	Name: "Template",

	Libraries: [],

	Events: {

		'Metadata Loaded': function() {

			this.autoSelectTemplate();

		}

	},

	Actions: {

		'WebsitesUpdated': function (websites) {
			Metadata.Websites = websites;
		},

		'CreativeDownloadLink': function(url) {

			const link = document.createElement("a");
			link.href = url;
			link.download = url.split('/').pop();
			link.click();

		},

		'CreateCssForDomainResult': function (params) {

			Broadcast.call('Create Css Domain Result', [params.error, params.result]);

		},

		'WebsitesCSSResults': function (params) {

			Broadcast.call('Websites Css Results', [params.error, params.results]);

		},

		'DeleteCssForDomainResult': function (params) {

			Broadcast.call('Delete Css Domain Result', [params.error, params.result]);

		}

	},

	init() {

		//Текущий шаблон
		this.SelectedTemplate = null;

	},

	selectTemplate(template_id) {

		if (Metadata.Templates[template_id]) {

			this.SelectedTemplate = Metadata.Templates[template_id];

			Layout.setTemplate(template_id);

			Broadcast.call("Selected Template Changed", [template_id]);

			window.localStorage.setItem('selected-template-id', template_id);

			//Broadcast.call("Settings Selected", [Settings.SelectedSettings], {delay: 10});

		}

	},

	autoSelectTemplate() {

		//Отменяем сброс активного шаблона при переподключении к серверу (после потери связи с сервером чтобы не сбрасывался текущий экран интерфейса)
		if (this.SelectedTemplate && Metadata.Templates[this.SelectedTemplate.id]) return;

		if (window.localStorage.getItem('selected-template-id')) {

			let template_id = parseInt(window.localStorage.getItem('selected-template-id'));

			if (Metadata.Templates[template_id]) return this.selectTemplate(template_id);

		}

		this.selectTemplate(_.values(Metadata.Templates)[0].id);

	},

	downloadWebsitesCode() {

		let template = this.SelectedTemplate.id;

		let fileName = 'websites.json';
		let fileFolder = 'websites';
		if (template === 5) fileFolder = 'websites-mobile';
		//else if (template === 8) fileFolder = 'websites-interscroller'

		let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${fileFolder}/${fileName}`;

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let websitesUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = websitesUrl;
			tag.download = fileFolder + '.json';
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();
	},

	downloadJson(domain) {

		let fileName = domain ? domain + '.json' : 'websites.json';
		let fileFolder = 'websites';

		let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${fileFolder}/${fileName}`;

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let websitesUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = websitesUrl;
			tag.download = fileName;
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();
	},

	downloadSteamJSON() {

		let folder = 'steam-json';

		let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${folder}/steam-json.json`;

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let stylesUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = stylesUrl;
			tag.download = 'steam-json.json';
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();
	},
	uploadSteamJSON(file) {
		let formData = new FormData();

		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/steamjson/get';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/steamjson/get';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.send(formData);
	},
	downloadExtraStyles(domain) {

		const folder = 'websites';
		const fileName = domain ? domain + '.css' : 'extra-styles.css';

		let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${folder}/${fileName}`;

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let stylesUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = stylesUrl;

			const downloadFileName = domain ? domain + '.css' : 'extra-styles.css';
			tag.download = downloadFileName
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();
	},
	uploadWebsitesCode(file) {

		let formData = new FormData();

		formData.append("file", file);
		formData.append("template", this.SelectedTemplate.id);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/websites/get';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/websites/get';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.send(formData);

	},

	uploadJson(file, domain) {

		let formData = new FormData();

		formData.append("file", file);
		formData.append("template", this.SelectedTemplate.id);
		if (domain) formData.append("domain", domain);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/json/upload';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/json/upload';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.send(formData);

		// if (!domain) return;
		xhr.onload = () => {

			if (xhr.status !== 400) return;

			Broadcast.call("Show Error Notification", ['Upload JSON Error', xhr.responseText]);


		};

	},

	uploadExtraStyles(file, domain) {

		let formData = new FormData();

		formData.append("file", file);
		if (domain) formData.append("domain", domain);
		formData.append("template", this.SelectedTemplate.id);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/styles/get';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/styles/get';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.send(formData);

		if (!domain) return;
		xhr.onload = () => {


			if (xhr.status !== 200) {

				Broadcast.call("Show Error Notification", ['Upload CSS Error', xhr.responseText]);

				return;
			}

			const websiteCss = JSON.parse(xhr.responseText);

			Broadcast.call('Upload Website Css', [websiteCss]);

		};

	},

	updateBannerIFrameSize() {
		if (!document.querySelector('.preview-frame > iframe')) return;
		let iframeDocument = document.querySelector('.preview-frame > iframe').contentWindow.document;
		let bannerWrapper = iframeDocument.querySelector('#banner-placeholder');
		if (!bannerWrapper) return;
		let iframe = bannerWrapper.querySelector('iframe');
		let settings = Settings.SettingsByProjectByCodename[Project.SelectedProject.id];
		if (!settings) return;
		if (!settings['banner-width'] || !settings['banner-height']) return;
		let width = settings['banner-width'].value;
		let height = settings['banner-height'].value;

		bannerWrapper.style.width = width + 'px';
		iframe.width = width;
		bannerWrapper.style.height = height + 'px';
		iframe.height = height;
	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Template = Template;

export { Template }

